import { io } from "socket.io-client";

console.log("🔌 Socket URL:", process.env.REACT_APP_SOCKET_URL);

const socket = io(process.env.REACT_APP_SOCKET_URL, {
  transports: ["websocket"],
});

socket.on("connect", () => {
  console.log("✅ Socket Connected");
  console.log("🔗 Socket URL:", socket.io.uri);
  console.log("🆔 Socket ID:", socket.id);
});

socket.on("connect_error", (error) => {
  console.error("❌ Socket Connection Error:", error.message);
  console.log("🔗 Trying to connect URL:", process.env.REACT_APP_SOCKET_URL);
});

socket.on("disconnect", (reason) => {
  console.log("❌ Socket Disconnected:", reason);
});

export default socket;
